import script from "./batchOperation.vue?vue&type=script&lang=ts&setup=true"
export * from "./batchOperation.vue?vue&type=script&lang=ts&setup=true"

import "./batchOperation.vue?vue&type=style&index=0&id=5949573c&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5949573c"]])

export default __exports__